import { render, staticRenderFns } from "./AdItemEditForm.vue?vue&type=template&id=1f0b59a6&"
import script from "./AdItemEditForm.vue?vue&type=script&lang=ts&"
export * from "./AdItemEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports